import React, {useEffect, useState} from "react"
import {Accordion, Card, Col, Container, Row} from "react-bootstrap"
import {getPipelineStatus} from "../../API/anaysestatus"
import {finalize_pipeline} from "../../Utils/helpers"
import ErrorComponent from "./ErrorComponent"
import LogsComponent from "./LogsComponent"


function LVAnalyseStatusViewComponent(props) {
	
	const [pipelineStatus, setPipelineStatus] = useState([])
	const [lvObject, setLVObject] = useState([])
	
	const finalize = async (lvID) => {
		await finalize_pipeline(lvID)
		sessionStorage.setItem('Render', JSON.stringify(1))
		window.location.href = process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE
	}
	
	const retrievePipelineStatusIcon = (result) => {
		
		if (result.pipeline.status === "Pending") {
			return <span className="fa fa-2x fa-exclamation text-info"
			             id="expanded-message-icon"/>
		} else if (result.pipeline.status === "Success") {
			return <span className="fa fa-2x fa-check-circle text-success"
			             id="expanded-message-icon"/>
		} else {
			return <span className="fa fa-2x fa-times-circle text-danger"
			             id="expanded-message-icon"/>
		}
		
	}
	
	const mainPipelineStatus = (result) => {
		
		return (<>
			<div className="col-md-1"/>
			<div className="col-md-9" id="expanded-message-status">
				<div className="row">
					{retrievePipelineStatusIcon(result)}
					<div className="col-lg-10 handwai-text-label-main">
						<p> {props.lvObjectIN[0].project_name}: &emsp;
							{result.pipeline.status} </p>
					</div>
				</div>
			</div>
			<div className="col-md-1"/>
		</>)
		
	}
	
	const retrieveModelStatusIcon = (aiModelStatus) => {
		
		if (aiModelStatus === "Pending") {
			return <span
				className="fa fa-exclamation-circle text-warning"/>
		} else if (aiModelStatus === "Success") {
			return <span className="fa fa-check-circle text-success"/>
		} else {
			return <span className="fa fa-times-circle text-danger"/>
		}
		
	}

	const formatProcessStatus = (aiModelName, aiModelStatus) => {
		if (aiModelName === "categories") {
			return `Labelling pipeline: ${aiModelStatus}`
		}
		return `Model ${aiModelName}: ${aiModelStatus}`
	}
	
	const individualPipelineStatus = (result, aiModelName) => {
		
		let aiModelStatus = "Not started"
		let aiModelReason = ""
		
		switch (aiModelName) {
			case "brands":
				aiModelStatus = result.process.brands?.status
				aiModelReason = result.process.brands?.reason
				break
			case "beschilderung":
				aiModelStatus = result.process.beschilderung?.status
				aiModelReason = result.process.beschilderung?.reason
				break
			case "geruste":
				aiModelStatus = result.process.geruste?.status
				aiModelReason = result.process.geruste?.reason
				break
			case "sites":
				aiModelStatus = result.process.sites?.status
				aiModelReason = result.process.sites?.reason
				break
			case "categories":
				if (result.process.categories != null) {
					aiModelStatus = result.process.categories.status
					aiModelReason = result.process.categories.reason
				}
				break
			/*case "stundenlohnarbeiten":
				aiModelStatus = result.process.stundenlohnarbeiten.status
				aiModelReason = result.process.stundenlohnarbeiten.reason
				break*/
			default:
				console.log("Sorry, " + aiModelName + " is invalid.")
		}
		
		
		return (<>
			<br/> <br/>
			<div className="col-md-8">
				<div className="row">
					<div className="col-md-1">
						{retrieveModelStatusIcon(aiModelStatus)}
					</div>
					<div
						className="col-md-10 bold">{formatProcessStatus(aiModelName, aiModelStatus)}</div>
					{aiModelStatus === "Pending" && (<div>
						<div
							className="spinner-border border-info spinner-border-lg"
							role="status">
							<span className="sr-only">Loading</span>
						</div>
					</div>)}
				</div>
				<div className="row">
					<div className="col-md-1"/>
					<div className="col-md-10 text-justify medium">
						{aiModelReason}
					</div>
				</div>
			</div>
			<div className="col-md-3"/>
		
		</>)
	}
	
	useEffect(() => {
		
		setLVObject(props.lvObjectIN)
		console.log(props.lvObjectIN)
		
		if (props.lvObjectIN !== undefined) {


			const lvID = props.lvObjectIN[0].uploadlv_id
			
			getPipelineStatus(lvID).then((result) => {

				const statuses = <Container>
					
					<Row>
						
						{mainPipelineStatus(result)}
					
					</ Row>
					
					<br/><br/>
					
					<Row>
						
						{individualPipelineStatus(result, "brands")}
						{individualPipelineStatus(result, "beschilderung")}
						{individualPipelineStatus(result, "geruste")}
						{individualPipelineStatus(result, "sites")}
						{individualPipelineStatus(result, "categories")}
{/*
						{individualPipelineStatus(result, "stundenlohnarbeiten")}
*/}

					</ Row>
					
					<br/>
					
					<Row>
						
						<Col md={10}>
							<Accordion>
								<Card className="handwai-dark">
									<Card.Header>
										<Accordion.Toggle as={Card.Header}
										                  className="handwai-btn-create"
										                  eventKey="0">
											Logs
										</Accordion.Toggle>
									</Card.Header>
									<Accordion.Collapse eventKey="0">
										<Card.Body><LogsComponent
											logs={result.results}
											process="all"/></Card.Body>
									</Accordion.Collapse>
								</Card>
								<Card className="handwai-dark">
									<Card.Header>
										<Accordion.Toggle as={Card.Header}
										                  className="handwai-btn-create"
										                  eventKey="1">
											Errors
										</Accordion.Toggle>
									</Card.Header>
									<Accordion.Collapse eventKey="1">
										<Card.Body> {result.pipeline.status !== "Pending" && (
											<ErrorComponent
												logs={result.errors}/>)}</Card.Body>
									</Accordion.Collapse>
								</Card>
							</Accordion>
						</Col>
					</Row>
					
					<br/>
					
					<Row>
						<Col/>
						<Col>
							<button onClick={() => finalize(lvID)}
							        className="btn handwai-btn-green addWidth90">Finalize
							</button>
						</Col>
						<Col/>
					</Row>
					
					<br/> <br/>
				</Container>
				
				// Set the state
				setPipelineStatus([statuses])
			})
		}
		
	}, [lvObject])
	
	return (<>
		<div className="container handwai-dark handwai-text-label-normal">
			{pipelineStatus}
		</div>
	</>)
	
}

export default LVAnalyseStatusViewComponent